var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrateVoiceWhatsappFacebookInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 221,
    height: 221,
    viewBox: "0 0 221 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Integrate_Voice_Whatsapp_Facebook_Instagram",
    "data-name": "Integrate Voice, Whatsapp, Facebook & Instagram",
    transform: "translate(-17217 -8411)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_588",
    "data-name": "Ellipse 588",
    cx: 110.5,
    cy: 110.5,
    r: 110.5,
    transform: "translate(17217 8411)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "integration",
    transform: "translate(17254.727 8447.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19707",
    "data-name": "Path 19707",
    d: "M41.018,41.9h0A11.426,11.426,0,0,1,52.45,53.332v6.314A11.445,11.445,0,0,1,41.021,71.078,21.765,21.765,0,0,1,34.1,69.952L33,69.588v25.8H64.607V76L96.213,99.179V69.588l-1.1.367a21.853,21.853,0,0,1-6.917,1.121A11.443,11.443,0,0,1,76.763,59.646V53.33A11.443,11.443,0,0,1,88.192,41.9a21.769,21.769,0,0,1,6.927,1.126l1.094.365V24.881a2.432,2.432,0,0,0-2.431-2.431H68.526l2.964-8.884A8.03,8.03,0,0,0,63.872,3H60.478a8.03,8.03,0,0,0-7.617,10.566l2.964,8.884H35.431A2.432,2.432,0,0,0,33,24.881V43.391l1.1-.365A21.813,21.813,0,0,1,41.018,41.9Z",
    transform: "translate(42.938 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19708",
    "data-name": "Path 19708",
    d: "M15.437,87.207a2.428,2.428,0,0,0,4.15-1.716V80.8h19.45v4.69a2.429,2.429,0,0,0,4.15,1.719L46.507,83.9,58,95.388H68.213V62.843l7.5,2.494a16.974,16.974,0,0,0,5.385.875,6.575,6.575,0,0,0,6.567-6.567V53.332A6.566,6.566,0,0,0,81.1,46.765h0a17.037,17.037,0,0,0-5.383.873l-7.5,2.5V24.881a2.432,2.432,0,0,0-2.431-2.431H40.526l2.964-8.884A8.03,8.03,0,0,0,35.872,3H32.478a8.03,8.03,0,0,0-7.617,10.566l2.964,8.884H7.431A2.432,2.432,0,0,0,5,24.881V91.012l7.119-7.119ZM56.057,49.194a4.863,4.863,0,1,1-4.863,4.863A4.861,4.861,0,0,1,56.057,49.194Zm-19.45,0a4.863,4.863,0,1,1-4.863,4.863A4.861,4.861,0,0,1,36.607,49.194Zm-19.45,0a4.863,4.863,0,1,1-4.863,4.863A4.861,4.861,0,0,1,17.156,49.194Z",
    transform: "translate(2.863 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19709",
    "data-name": "Path 19709",
    d: "M109.529,59.077l-30.14-22.1V51.625H27.5l-.71.712a2.428,2.428,0,0,0,1.714,4.15h4.69V71.075H79.389V85.2Z",
    transform: "translate(33.018 48.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19710",
    "data-name": "Path 19710",
    d: "M54.784,56.808a7.175,7.175,0,0,1,1.464-7.824L49.367,42.1A7.293,7.293,0,0,1,37.04,37H27.31a7.293,7.293,0,0,1-12.327,5.1L8.106,48.986A7.179,7.179,0,0,1,9.569,56.81,7.178,7.178,0,0,1,3,61.31v9.73a7.171,7.171,0,0,1,6.567,4.5A7.175,7.175,0,0,1,8.1,83.367l6.88,6.88a7.293,7.293,0,0,1,12.327,5.1h9.73a7.293,7.293,0,0,1,12.327-5.1l6.88-6.88a7.293,7.293,0,0,1,5.1-12.327V61.31A7.171,7.171,0,0,1,54.784,56.808ZM32.175,83.194A17.019,17.019,0,1,1,49.194,66.175,17.019,17.019,0,0,1,32.175,83.194Z",
    transform: "translate(0 48.663)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_628",
    "data-name": "Ellipse 628",
    cx: 7.294,
    cy: 7.294,
    r: 7.294,
    transform: "translate(24.881 107.545)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrateVoiceWhatsappFacebookInstagram);
export default __webpack_public_path__ + "static/media/Integrate Voice, Whatsapp, Facebook _ Instagram.182945b862f3bae985cb4cad5239c8d2.svg";
export { ForwardRef as ReactComponent };